export default __webpack_public_path__ + "static/media/edit-red.9a77a6ab.svg";